import { TypographyProps } from "@mui/material";
import { FC, ReactNode, forwardRef } from "react";

import TypographyRoot from "./TypographyRoot";
import { useMaterialUIController } from "../context";

interface IProps extends TypographyProps {
    variant?: 'body1' | 'body2' | 'button' | 'caption' | 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6' | 'inherit' | 'overline' | 'subtitle1' | 'subtitle2';
    color?: "inherit" | "primary" | "secondary" | "info" | "success" | "warning" | "error" | "light" | "dark" | "text" | "white";
    verticalAlign?: "unset" | "baseline" | "sub" | "super" | "text-top" | "text-bottom" | "middle" | "top" | "bottom";
    textTransform?: "none" | "capitalize" | "uppercase" | "lowercase";
    fontWeight?: "light" | "regular" | "medium" | "bold" | undefined;
    textGradient?: boolean;
    children: ReactNode;
    component?: string;
    opacity?: number;
    href?: string;
    // [key: string]: any;
}

const Typography = forwardRef<HTMLSpanElement, IProps>(
    ({ color, fontWeight, textTransform, verticalAlign, textGradient, opacity, children, ...rest }, ref) => {
        const [controller] = useMaterialUIController();
        const { darkMode } = controller;
        return (
            <TypographyRoot
                {...rest}
                ref={ref}
                ownerState={{
                    color,
                    opacity,
                    darkMode,
                    fontWeight,
                    textGradient,
                    textTransform,
                    verticalAlign,
                }}
            >
                {children}
            </TypographyRoot>
        );
    }
);

// Declaring default props for Typography
Typography.defaultProps = {
    color: "dark",
    variant: "body1",
    fontWeight: undefined,
    textTransform: "none",
    verticalAlign: "unset",
    textGradient: false,
    opacity: 1,
};

export default Typography;
